<template>
    <div  class="m-portlet m-portlet--head-sm" v-loading="$parentInfo.studentWeekTable.loading">
        <div>
            <div>
                <h3 style="margin-left: 20px">{{$parentInfo.studentWeekTable.filter.date}}</h3>
                <div style="margin-top: -33px;margin-bottom: 15px;text-align: center;">
                    <el-button-group>
                        <el-button type="success" icon="el-icon-arrow-left" @click="handleLastWeek" style="height: 33px"></el-button>
                        <el-button type="success" @click="handleToday" style="height: 33px">今天</el-button>
                        <el-button type="success" @click="handleNextWeek" style="height: 33px"><i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    </el-button-group>
                </div>
            </div>
            <div  class="m-portlet__body"  v-if="$parentInfo.studentWeekTable.V4Judge">
                <StudentWeekTable ref="V4Table"
                              v-show="$parentInfo.studentWeekTable.V4Show"> </StudentWeekTable>
            </div>
        </div>
    </div>
</template>
<script>
    import index from './Index';
    export default {
        name: "OperationTeacher",
        data() {
            return {
            }
        },
        components: {
            'StudentWeekTable': index,
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShow()
        },
        methods: {
            handleLastWeek(){
                this.$parentInfo.studentWeekTable.filter.date=this.$moment(this.$parentInfo.studentWeekTable.filter.date).subtract(7, 'days').format('YYYY-MM-DD')
                this.handleShow();
            },
            handleToday(){
                this.$parentInfo.studentWeekTable.filter.date=this.$moment().format('YYYY-MM-DD');
                this.handleShow();
            },
            handleNextWeek(){
                this.$parentInfo.studentWeekTable.filter.date=this.$moment(this.$parentInfo.studentWeekTable.filter.date).add(7, 'days').format('YYYY-MM-DD')
                this.handleShow();
            },
            handleShow(){
                this.$parentInfo.studentWeekTable.loading = true;
                this.$parentInfo.studentWeekTable.V4Show = false;
                this.$parentInfo.studentWeekTable.V4Judge = false;
                this.$wApi.send(this.$parentInfo.path,'show_weekTable',
                    {'date':this.$parentInfo.studentWeekTable.filter.date,
                     'student_id':this.$parentInfo.student_id});

            }
        }
    }
</script>

<style scoped>

</style>